import { __extends, __read, __spreadArray, __values } from "tslib";
import { warn } from '@tencent/memoire-error-utils';
import { UnexpectedModifierError } from './errors';
import { ExecutionStage } from './execution';
import BaseAspect from './base-aspect';
/**
 * SyncAspect is an `Aspect` that execute modifiers in sync mode
 */
var SyncAspect = /** @class */ (function (_super) {
    __extends(SyncAspect, _super);
    function SyncAspect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncAspect.create = function () {
        return new SyncAspect(function () { return ({}); });
    };
    SyncAspect.withContext = function (contextCreator) {
        return new SyncAspect(contextCreator);
    };
    /**
     * Call the patched function & execute the modifiers when it's needed
     */
    SyncAspect.prototype.invoke = function (fn, currentThis, args) {
        var _a;
        if (!this.dirty()) {
            return fn.call.apply(fn, __spreadArray([currentThis], __read(args)));
        }
        var ctx = Object.assign(this.createContext(), {
            args: args,
            this: currentThis,
            callee: fn,
            return: undefined,
            error: undefined,
        });
        try {
            this.trigger(ExecutionStage.before, ctx, this.modifiers.protect);
            if (!this.modifiers.around.length) {
                ctx.return = (_a = ctx.callee).call.apply(_a, __spreadArray([ctx.this], __read(ctx.args)));
            }
            else {
                this.trigger(ExecutionStage.around, ctx, this.modifiers.protect);
            }
            this.trigger(ExecutionStage.return, ctx, this.modifiers.protect);
        }
        catch (error) {
            if (this.modifiers.throw.length) {
                Object.assign(ctx, { error: error });
                this.trigger(ExecutionStage.throw, ctx, this.modifiers.protect);
            }
            throw error;
        }
        finally {
            this.trigger(ExecutionStage.after, ctx, this.modifiers.protect);
        }
        return ctx.return;
    };
    /**
     * Trigger all the modifiers in a stage, catch all errors if the modifier called failed.
     * The caught errors can be handled in protect stage
     */
    SyncAspect.prototype.trigger = function (stage, ctx, protectors) {
        var e_1, _a, e_2, _b;
        try {
            for (var _c = __values(this.modifiers[stage]), _d = _c.next(); !_d.done; _d = _c.next()) {
                var modifier = _d.value;
                try {
                    modifier.call(ctx.this, ctx);
                }
                catch (error) {
                    if (!protectors.length) {
                        warn(new UnexpectedModifierError(stage, error));
                        continue;
                    }
                    try {
                        for (var protectors_1 = (e_2 = void 0, __values(protectors)), protectors_1_1 = protectors_1.next(); !protectors_1_1.done; protectors_1_1 = protectors_1.next()) {
                            var protector = protectors_1_1.value;
                            Object.assign(ctx, { error: error });
                            protector.call(ctx.this, ctx);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (protectors_1_1 && !protectors_1_1.done && (_b = protectors_1.return)) _b.call(protectors_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return SyncAspect;
}(BaseAspect));
export default SyncAspect;
//# sourceMappingURL=sync-aspect.js.map